import InstantOatmealProduct from 'models/InstantOatmealProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import InstantOatmealNutrition from './InstantOatmealNutrition'
import InstantOatmealPackage from './InstantOatmealPackage'

const productOptions = {
  nutritionInfo: <InstantOatmealNutrition />,
  packagingInfo: <InstantOatmealPackage />,
  productTitle: 'Brand Specific Whole Grain Instant Oatmeal',
  model: InstantOatmealProduct,
  validCategories: ['05'],
  validSubCategories: ['001IO'],
  brandSpecific: true,
}

const BSInstantOatmeal = () => <ProductForm product={productOptions} />

export default BSInstantOatmeal
